var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyMagnifier = function SvgSurveyMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 98 85"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4E00",
    fillRule: "evenodd",
    d: "M97.203 28.14a2.62 2.62 0 0 1 .058 3.707L66.926 63.16a2.62 2.62 0 0 1-3.765 0l-9.102-9.394a2.621 2.621 0 0 1 3.765-3.647l7.219 7.45L93.497 28.2a2.62 2.62 0 0 1 3.706-.058",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4E00",
    fillRule: "evenodd",
    d: "M43.808 28.467a4.4 4.4 0 0 0-3.16 1.356 4.8 4.8 0 0 0-1.335 3.334v43.838c0 1.26.485 2.457 1.334 3.334a4.4 4.4 0 0 0 3.161 1.355H86.28a4.4 4.4 0 0 0 3.16-1.355 4.8 4.8 0 0 0 1.335-3.334v-21.92a1.573 1.573 0 1 1 3.145 0v21.92c0 2.062-.793 4.05-2.22 5.522a7.55 7.55 0 0 1-5.42 2.313H43.808a7.55 7.55 0 0 1-5.42-2.313 7.94 7.94 0 0 1-2.22-5.522V33.157c0-2.063.793-4.05 2.22-5.523a7.55 7.55 0 0 1 5.42-2.313h33.37a1.573 1.573 0 1 1 0 3.145z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 26.5,
    r: 21.5,
    fill: "#D9D9D9",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "m23.217 43.308-6.405 9.034 4.599 3.235 6.405-9.034z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    fillRule: "evenodd",
    d: "M53.963 4.813C42.068-3.558 25.6-.729 17.205 11.12c-8.405 11.849-5.573 28.252 6.33 36.615 11.895 8.372 28.354 5.543 36.758-6.305 8.405-11.849 5.564-28.244-6.33-36.616M55.987 38.4c-6.722 9.484-19.891 11.74-29.412 5.045-9.52-6.696-11.786-19.814-5.064-29.297 6.722-9.476 19.89-11.74 29.412-5.045C60.435 15.8 62.7 28.917 55.987 38.4M21.678 50.349c-2.374-1.668-5.681-1.103-7.355 1.261l-2.283 3.22L.962 70.453a5.256 5.256 0 0 0 1.266 7.326c2.374 1.668 5.681 1.104 7.355-1.26l11.079-15.624 2.282-3.22a5.256 5.256 0 0 0-1.266-7.326",
    clipRule: "evenodd"
  })));
};
export default SvgSurveyMagnifier;